import axios from 'axios';
import {backendHost} from '../../config';

export const getEvents = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/events`, {params});
};